import type { RadioFieldProps, TextFieldProps } from "$components/inputs";
import TextField from "$components/rhf/text-field";
import { RadioGroupField as RHFRadioField } from "$components/rhf-fields";
import type { JSONSchema } from "@elephant-healthcare/yupify";
import React from "react";

interface RadioOption {
  value: string;
  label: string;
}

type DynamicInputProps = (RadioFieldProps | TextFieldProps) & {
  fieldDef: JSONSchema;
  options?: RadioOption[];
  name: string;
};

const DynamicInput = ({
  fieldDef,
  options,
  ...props
}: DynamicInputProps): React.ReactElement => {
  if (options) {
    return <RHFRadioField options={options} {...(props as RadioFieldProps)} />;
  }

  const numberInputProps =
    fieldDef.type === "number"
      ? {
          ...(props as TextFieldProps).inputProps,
          min: fieldDef.minimum,
          max: fieldDef.maximum,
        }
      : {};

  return (
    <TextField
      type={fieldDef.type as string}
      {...(props as TextFieldProps & { name: string })}
      inputProps={numberInputProps}
    />
  );
};

DynamicInput.defaultProps = {
  options: undefined,
};

export default DynamicInput;
